import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { ModalService } from 'src/app/services/modal.service';
import { endLeagueGame } from 'src/app/store/actions/game.action';
import { AppState } from 'src/app/store/app.state';

@Component({
  selector: 'app-update-league-game',
  templateUrl: './update-league-game.component.html',
  styleUrls: ['./update-league-game.component.scss']
})
export class UpdateLeagueGameComponent implements OnInit {

  game!: any;
  league!: any;

  form: FormGroup;

  players: any = [];

  constructor(
    private fb: FormBuilder,
    private modalService: ModalService,
    private store: Store<AppState>
  ) { }

  ngOnInit() {
    console.log(this.league);
    this.form = this.fb.group({
      status: ['', new FormControl()],
      score1: ['', new FormControl()],
      score2: ['', new FormControl()],
      total1: ['', new FormControl()],
      total2: ['', new FormControl()],
      margin1: ['', new FormControl()],
      margin2: ['', new FormControl()],
      winner: ['', new FormControl()],
      loser: ['', new FormControl()],
      winType: ['', new FormControl()],
    })

    this.players.push(this.game?.player1, this.game?.player2);
  }

  close(){
    this.modalService.hideUpdateLeagueGame();
  }

  updateGame(){
    const payload = {
      status: this.status?.value,
      score1: this.score1?.value,
      score2: this.score2?.value,
      total1: this.total1?.value,
      total2: this.total2?.value,
      margin1: this.margin1?.value,
      margin2: this.margin2?.value,
      winner: this.winner?.value,
      loser: this.loser?.value,
      winType: this.winType?.value,
    }

    this.modalService.showLoadingSpinner();
    this.store.dispatch(endLeagueGame({data: payload, league: this.league, game: this.game}))
  }

  selectWinner(event){
    const getLoser = this.players?.filter((e) => e?.playerId !== event?.value)[0];
    this.form.patchValue({
      loser: getLoser?.playerId
    })
  }

  selectLoser(event){
    const getWinner = this.players?.filter((e) => e?.playerId !== event?.value)[0];
    this.form.patchValue({
      winner: getWinner?.playerId
    })
  }

  get status(){
    return this.form.get('status');
  }

  get score1(){
    return this.form.get('score1');
  }

  get score2(){
    return this.form.get('score2');
  }

  get total1(){
    return this.form.get('total1');
  }

  get total2(){
    return this.form.get('total2');
  }

  get margin1(){
    return this.form.get('margin1');
  }

  get margin2(){
    return this.form.get('margin2');
  }

  get winner(){
    return this.form.get('winner');
  }

  get loser(){
    return this.form.get('loser');
  }

  get winType(){
    return this.form.get('winType');
  }

}
